// ---------------------------------------------------------------------------
// ÖZELLİK ANAHTARLARI
// Açmak/kapatmak için true veya false yazman yeterli; kod silmeye gerek yok.
// ---------------------------------------------------------------------------
export const FEATURES = {
  /** Sayfa açılışında çıkan "Önemli Hatırlatma" modalı */
  acilisHatirlatmasi: false,

  /** Tanıtım adımındaki proje künyesi kutuları (alan, blok, daire) */
  projeKunyesi: true,

  /** "Başvuru Sorgula" sekmesi */
  basvuruSorgulama: true
};

// Açılış hatırlatması içeriği (FEATURES.acilisHatirlatmasi true ise gösterilir)
export const WELCOME_ALERT = {
  gecikmeMs: 1000,
  baslik: 'Önemli Hatırlatma',
  mesaj: 'Ön başvuru yapmadan önce konut tiplerini ve ödeme tablosunu incelemeniz önerilir.'
};

// Backend API
export const API_BASE_URL = 'https://app.yanibasimdakaratay.com/api/kooperatif';

// Başvuru dönemi. Backend'deki DONEM_BASLANGIC / DONEM_BITIS ile aynı tutulmalıdır;
// nihai kontrol her hâlükârda sunucuda yapılır.
export const APPLICATION_PERIOD = {
  start: '2026-08-10T00:00:00+03:00',
  end: '2026-08-16T23:59:59+03:00',
  text: '10 Ağustos 2026 - 16 Ağustos 2026'
};

/** Cihaz saatine göre dönem açık mı (bilgilendirme amaçlı; asıl kontrol sunucuda) */
export const isApplicationPeriodOpen = () => {
  const now = Date.now();
  return now >= new Date(APPLICATION_PERIOD.start).getTime()
    && now <= new Date(APPLICATION_PERIOD.end).getTime();
};

// Konut tipleri.
// daireSayisi bilgilendirme amaçlıdır; ön başvuru sayısı daire sayısını aşabilir,
// fazlalık durumunda üyeler noter huzurunda kura ile belirlenir.
export const HOUSING_TYPES = [
  {
    kod: 'TIP1',
    baslik: 'Tip 1',
    konsept: '3+1',
    metrekare: '136 m²',
    daireSayisi: 168,
    onBasvuruBedeli: '10.000 TL',
    pesinat: '1.000.000 TL',
    aidat: '60.000 TL'
  },
  {
    kod: 'TIP2',
    baslik: 'Tip 2',
    konsept: '2+1',
    metrekare: '109 m²',
    daireSayisi: 30,
    onBasvuruBedeli: '8.000 TL',
    pesinat: '865.000 TL',
    aidat: '52.000 TL'
  },
  {
    kod: 'TIP3',
    baslik: 'Tip 3',
    konsept: '2+1',
    metrekare: '88 m²',
    daireSayisi: 26,
    onBasvuruBedeli: '6.000 TL',
    pesinat: '725.000 TL',
    aidat: '43.000 TL'
  }
];

// Proje künyesi
export const PROJECT_INFO = {
  toplamAlan: '31.603 m²',
  blokSayisi: 30,
  daireSayisi: 350,
  alinacakUyeSayisi: 224,
  konum: 'Selimsultan Mahallesi — Çancı Caddesi, Selimsultan Caddesi ve İskender Caddesi arasında'
};

// Ekran modları
export const VIEWS = {
  FORM: 'form',
  STATUS: 'status'
};

// Başvuru durumu renk şeması
export const STATUS_STYLES = {
  pending: { bg: 'bg-amber-50', border: 'border-amber-300', text: 'text-amber-800', dot: 'bg-amber-500' },
  paid: { bg: 'bg-green-50', border: 'border-green-300', text: 'text-green-800', dot: 'bg-green-500' },
  cancelled: { bg: 'bg-red-50', border: 'border-red-300', text: 'text-red-800', dot: 'bg-red-500' }
};

export const DEFAULT_STATUS_STYLE = {
  bg: 'bg-gray-50', border: 'border-gray-300', text: 'text-gray-800', dot: 'bg-gray-500'
};

// Kura sonucu renk şeması.
// Sonuçlar backend'de yönetici "Yayınla" demeden dönmediği için burada ayrı bir
// gösterim koşulu yok; API kura alanını gönderiyorsa sonuç açıklanmış demektir.
export const KURA_STYLES = {
  ASIL: {
    bg: 'bg-emerald-50',
    border: 'border-emerald-300',
    text: 'text-emerald-900',
    badge: 'bg-emerald-600',
    icon: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
  },
  YEDEK: {
    bg: 'bg-sky-50',
    border: 'border-sky-300',
    text: 'text-sky-900',
    badge: 'bg-sky-600',
    icon: 'M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z'
  },
  KAZANAMADI: {
    bg: 'bg-slate-50',
    border: 'border-slate-300',
    text: 'text-slate-800',
    badge: 'bg-slate-500',
    icon: 'M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
  }
};

/** Kura sonucu kartında sonucun üstünde görünen küçük etiket */
export const KURA_ROZETLERI = {
  ASIL: 'ASİL LİSTE',
  YEDEK: 'YEDEK LİSTE',
  KAZANAMADI: 'SONUÇ'
};

// Form step configuration
export const STEPS = {
  INTRO: 1,
  HOUSING_TYPE: 2,
  PERSONAL_INFO: 3,
  ADDRESS: 4,
  PAYMENT: 5
};

export const TOTAL_STEPS = 5;

export const STEP_TITLES = {
  1: 'Kooperatif Tanıtımı',
  2: 'Konut Tipi',
  3: 'Kişisel Bilgiler',
  4: 'Adres Bilgileri',
  5: 'Başvuru Onayı'
};

// Banka bilgileri (ön başvuru bedeli konut tipine göre HOUSING_TYPES'tan alınır)
export const PAYMENT_INFO = {
  bankName: 'KUVEYT TÜRK',
  accountHolder: 'SINIRLI SORUMLU KARATAY SELİM SULTAN KONAKLARI KONUT YAPI KOOPERATİFİ',
  iban: 'TR56 0020 5000 0925 7678 6000 01'
};

// Peşinat (kesin kayıt) hesabı. Ön başvuru hesabından FARKLIDIR:
// ön başvuru bedeli PAYMENT_INFO'daki ...6000 01, peşinat bedeli ise
// aşağıdaki ...6000 02 numaralı hesaba yatırılır.
export const PESINAT_PAYMENT_INFO = {
  bankName: 'KUVEYT TÜRK',
  accountHolder: 'SINIRLI SORUMLU KARATAY SELİM SULTAN KONAKLARI KONUT YAPI KOOPERATİFİ',
  iban: 'TR29 0020 5000 0925 7678 6000 02'
};

// Asil üyelik hakkı kazananların kesin kayıt süreci
export const KESIN_KAYIT = {
  sonTarih: '31 Ağustos 2026',
  sonTarihISO: '2026-08-31T23:59:59+03:00',
  evraklar: [
    { baslik: '2 adet fotoğraf', not: 'Son 6 ay içinde çekilmiş' },
    { baslik: 'İkametgah belgesi', not: 'e-Devlet üzerinden alınabilir' },
    { baslik: 'Kimlik fotokopisi', not: null },
    { baslik: 'Banka dekontu', not: 'Peşinat bedelinin yatırıldığını gösteren' }
  ]
};

/** Kesin kayıt son tarihi geçti mi (bilgilendirme amaçlı; cihaz saatine bakar) */
export const isKesinKayitOpen = () =>
  Date.now() <= new Date(KESIN_KAYIT.sonTarihISO).getTime();

// Kura sonucuna göre "bundan sonra ne olacak" bilgilendirmesi.
// KAZANAMADI için ayrıca bir yönlendirme yapılmadığından burada karşılığı yoktur.
export const KURA_BILGI = {
  ASIL: {
    baslik: 'Kesin Kayıt İşlemleri',
    ozet: 'Asil üyelik hakkı elde ettiniz. Üyeliğinizin kesinleşmesi için peşinat bedelini yatırmanız ve aşağıdaki evraklarla kesin kayıt yaptırmanız gerekmektedir.',
    // Sorgulama yapılmadan gösterilen genel metin (kişiye özel değil)
    genelBaslik: 'Asil Üyeler İçin Kesin Kayıt',
    genelOzet: 'Asil üyelik hakkı elde eden katılımcıların kesin kayıt yaptırabilmeleri için son tarih 31 Ağustos 2026’dır. Kayıt için peşinat bedelinin yatırılması ve aşağıdaki evrakların hazırlanması gerekmektedir.',
    uyarilar: [
      'Peşinat bedeli, ön başvuru bedelinin yatırıldığı hesaptan farklı bir hesaba yatırılmaktadır; lütfen yukarıdaki IBAN’ı kullanınız.',
      'Son tarihe kadar kesin kayıt yaptırmayan asil üyelerin yerine yedek listeden sırayla üye alınacaktır.'
    ]
  },
  YEDEK: {
    baslik: 'Yedek Üyeler İçin Bilgilendirme',
    ozet: 'Yedek listedesiniz. Asil listeden kesin kayıt yaptırmayan veya üyelikten vazgeçen olması hâlinde yedek sıranıza göre üyeliğe kabul edileceksiniz.',
    genelBaslik: 'Yedek Üyeler İçin Bilgilendirme',
    genelOzet: 'Yedek listede yer alan katılımcılar; asil listeden kesin kayıt yaptırmayan veya üyelikten vazgeçen olması hâlinde, yedek sıralarına göre üyeliğe kabul edilecektir.',
    uyarilar: [
      'Şu aşamada peşinat bedelini yatırmayınız; sıranız geldiğinde tarafınıza bildirim yapılacaktır.',
      'Asil üyelerin kesin kayıt süresi 31 Ağustos 2026 tarihinde sona ermektedir; yedek listeden üye alımı bu tarihten sonra yapılacaktır.',
      'Başvurunuzdaki telefon numarasının güncel ve ulaşılabilir olması önemlidir.',
      'Evrakları önceden hazırlamanız, sıranız geldiğinde işlemlerinizi hızlandıracaktır.'
    ]
  }
};

// KVKK modal content
export const KVKK_TEXT = `
KVKK AYDINLATMA METNİ

TANIMLAR

İşbu aydınlatma metninde geçen;
Kişisel Veri: Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgiyi,
Kişisel Verilerin Korunması Kanunu (“KVKK”): 7 Nisan 2016 tarihinde Resmi Gazete’de yayınlanarak yürürlüğe giren 6698 sayılı Kişisel Verilerin Korunması Kanunu’nu,
Karatay Belediye Başkanlığı: Akçeşme Mah. Garaj Cad. No: 5 Karatay/KONYA adresinde mukim Karatay Belediye Başkanlığı’nı,
Veri İşleyen: Veri sorumlusunun verdiği yetkiye dayanarak onun adına Kişisel Verileri işleyen gerçek veya tüzel kişiyi,
Veri Sorumlusu: Kişisel Verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin kurulmasından ve yönetilmesinden sorumlu olan gerçek veya tüzel kişiyi,
ifade eder.


VERİ SORUMLUSU

KVKK uyarınca muhatap, üye, bağışçı, bursiyer, stajyer, tedarikçi, ziyaretçi, hibe alan, ödül alan, desteklenen, Fark Yaratan, yarışmacı, program ortağı ve/veya vakıf çalışanı/yöneticisi sıfatıyla paylaştığınız kişisel verileriniz; veri sorumlusu olarak belirlenen Karatay Belediye Başkanlığı tüzel kişiliği tarafından aşağıda belirtilen kapsamda değerlendirilecektir.


KİŞİSEL VERİLERİN İŞLENME AMACI

KVKK’nın 4., 5. ve 6. maddeleri uyarınca kişisel verileriniz;

•	Hukuka ve dürüstlük kurallarına uygun
•	Doğru ve gerektiğinde güncel
•	Belirli, açık ve meşru amaçlar için
•	İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü
•	İlgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza edilme kurallarına uygun bir şekilde Karatay Belediye Başkanlığı’nın aşağıda yer alan faaliyetleri ile bağlantılı olacak şekilde işlenecektir.
 
KARATAY BELEDİYE BAŞKANLIĞI FAALİYETLERİ

•	Burs, staj ve yurt imkanları sağlamak
•	Kalıcı eser inşası ve onarımlarını yaptırmak, ortak proje ve programlar yapmak
•	Eğitim, sanat ve spor alanlarında ödüller vermek
•	Kültür ve sanat etkinlikleri düzenlemek/destek vermek
•	Hibe programları ve ortaklıklar oluşturmak
•	Seminerler düzenlemek
•	Faaliyetlere ait iletişimi sağlamak ve yürütmek


KİŞİSEL VERİLERİN AKTARIMI

KVKK’nın 8. ve 9. maddeleri uyarınca kişisel verileriniz yukarıda sayılan amaçlar dahilinde, Karatay Belediye Başkanlığı’nın faaliyetlerinin sürdürülebilmesi için Kişisel Veri işleme şartları ve amaçları çerçevesinde gerekli görülen üçüncü kişilere (program ortağı, işbirliği yapılan kurum, tedarikçi, bağışçı, vakıf yöneticileri/çalışanları, hukuken yetkili kamu kurumu ve kuruluşları, hukuken yetkili özel hukuk kişileri ya da yurt dışı ülkeler) aktarılabilecektir.


KİŞİSEL VERİLERİN TOPLANMA YÖNTEMİ VE HUKUKİ SEBEBİ

Kişisel verileriniz, Karatay Belediye Başkanlığı tarafından

•	Burs/Staj/Yurt Başvuru Formları
•	Karatay Belediye Başkanlığı Web Siteleri İletişim Formları
•	Karatay Belediye Başkanlığı Web Siteleri E-Bülten Kayıt Formları
•	Hibe Programı Başvuru Formları
•	İş Başvuru Formları
•	Yarışma Başvuru Formları gibi kanallarla ve farklı hukuki sebeplere dayanarak Karatay Belediye Başkanlığı’nın faaliyetlerini sürdürülebilmesi için KVKK tarafından öngörülen temel ilkelere uygun olarak, KVKK’nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları kapsamında işbu Aydınlatma Metninde belirtilen amaçlarla da toplanabilmekte, işlenebilmekte ve aktarılabilmektedir.


KİŞİSEL VERİ SAHİBİNİN HAKLARI

KVKK’nın 11. maddesi uyarınca herkes, veri sorumlusuna başvurarak kendisiyle ilgili;
a)	Kişisel verilerinin işlenip işlenmediğini öğrenme,
b)	Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,
c)	Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
ç) Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,
d)	Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,
e)	KVKK 7. maddede öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme,
f)	(d) ve (e) bentleri uyarınca yapılan işlemlerin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
g)	İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,
ğ) Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme,
haklarına sahiptir.

Yukarıda belirtilen haklarınız ile ilgili Karatay Belediye Başkanlığı’na yazılı olarak başvurmanız halinde, talebinizin niteliğine göre en geç 30 (otuz) gün içerisinde ücretsiz olarak yanıt verilecektir.
Başvurunuzu açık, anlaşır bir şekilde ve kimlik ve adres bilgilerinizi tespit edici belgeleri de ekleyerek, yazılı ve ıslak imzalı olarak elden, postayla ya da noter kanalıyla Karatay Belediye Başkanlığı Akçeşme Mah. Garaj Cad. No: 5 Karatay/KONYA adresine ulaştırmanız gerekmektedir.
`;

// Project location (Google Maps)
export const LOCATION_URL = 'https://maps.app.goo.gl/EKgEZb89acvDN4fq5';

// Intro step content
export const INTRO_CONTENT = {
  title: 'Karatay Selim Sultan Konakları Konut Yapı Kooperatifi',
  description: `Karatay Selim Sultan Konakları Konut Yapı Kooperatifi; Selimsultan Mahallesi Çancı Caddesi, Selimsultan Caddesi ve İskender Caddesi arasında kalan alanda projelendirildi.

Selimsultan Mahallesi'nde Belediyemiz öncülüğündeki ilk kooperatif çalışması olma özelliği taşıyan proje, toplam 31.603 m² alanıyla bölgedeki kentsel dönüşüm çalışmalarına büyük bir ivme kazandıracak.

30 bloktan oluşan proje, 2 ayrı ada üzerinde toplam 350 daireden meydana gelecek. Arsa sahiplerinin haklarının da belirlendiği projeye 224 yeni üyenin kabulü ön başvurularla sağlanacaktır.

Ön başvuru sayısının alınacak üye sayısından fazla olması durumunda noter huzurunda üyelik kurası gerçekleştirilecek ve kesin üyeler bu kura ile belirlenecektir.

Ön başvuru süreci toplamda 5 adımdan oluşmaktadır. Lütfen tüm bilgileri eksiksiz ve doğru bir şekilde doldurunuz.`
};

// Form notices
export const NOTICES = {
  iban: [
    'Ödeme açıklaması başvurunuza özel olarak sistem tarafından otomatik üretilmiştir; lütfen değiştirmeden kullanınız.',
    'Açıklama alanındaki kopyala ikonunu kullanarak bilgileri hatasız bir şekilde kopyalayıp banka uygulamanıza yapıştırabilirsiniz.',
    'Eksik veya hatalı açıklama içeren ödemeler eşleştirilemeyeceğinden ön başvurunuz geçersiz sayılacaktır.',
    'Ön başvuru sayısı daire sayısını aşarsa kesin üyeler noter huzurunda yapılacak kura ile belirlenecektir.'
  ]
};
